import styles from "./index.module.css";
import React, { PropsWithChildren, ReactNode } from "react";
import { AsideHint } from "@/components/AppShell/AsideHint";

interface Props {
  backButton: ReactNode | undefined;
  size: "lg" | "xl";
  hintMessage: React.ReactElement | string;
  isThankYouPage?: boolean;
}

export const DesktopView = ({ backButton, size, hintMessage, isThankYouPage = false, children }: Props & PropsWithChildren) => {
  return (
    <>
      <div className={styles.aside}>
        <div className={styles.desktopBackButton}>{backButton}</div>
      </div>
      <div className={styles.content}>
        <div className={styles.paper} data-size={size} data-thank-you={isThankYouPage}>
          {children}
        </div>
      </div>
      <AsideHint hintMessage={hintMessage} />
    </>
  );
};
